import { MedicinePrescription, StandardMedicinePrescription } from '../types';

export const isStandardMedicinePrescription = (
   medicinePrescription: MedicinePrescription
): medicinePrescription is StandardMedicinePrescription => {
   return 'patientMedicine' in medicinePrescription;
};
